export const environment = {
    appVersion: require('../../package.json').version + '-staging',
    apiUrl: 'https://fin-api-staging2.tourwow.com/',
    tourwowUrl: 'https://staging2.tourwow.com/',
    vibeCodeUrl: 'https://staging-finance-backoffice-report.vercel.app/',
    chatbotUrl: 'https://stg-tourwow-chatbot.vercel.app/',
    production: false,
    dateLanguage: 'th-TH',
};
